import { Box, Paper, Rating, Stack, Typography, Zoom } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TurnoInfoCard from './TurnoInfoCard';

const CalificacionResumen = ({ turno }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 3, sm: 4 },
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        textAlign: 'center',
      }}
    >
      <Zoom in timeout={600}>
        <CheckCircleIcon sx={{ fontSize: 48, color: 'success.main', mb: 1 }} />
      </Zoom>

      <Typography variant="h5" component="h1" fontWeight="700" gutterBottom>
        ¡Ya calificaste esta atención!
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Gracias por ayudarnos a mejorar.
      </Typography>

      <Stack spacing={3}>
        <TurnoInfoCard
          nombreSede={turno?.nombreSede}
          fecha={turno?.fecha}
          hora={turno?.hora}
          codigoMostrar={turno?.codigoMostrar}
        />

        <Box>
          <Rating value={turno?.valoracion || 0} readOnly size="large" sx={{ fontSize: '2.5rem' }} />
        </Box>

        {turno?.valoracionObservacion && (
          <Box sx={{ bgcolor: 'action.hover', p: 2, borderRadius: 2, textAlign: 'left' }}>
            <Typography variant="overline" color="text.secondary" display="block">
              Tu comentario
            </Typography>
            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
              {turno.valoracionObservacion}
            </Typography>
          </Box>
        )}
      </Stack>
    </Paper>
  );
};

export default CalificacionResumen;
